import { render, staticRenderFns } from "./TodoDetailsSkeleton.vue?vue&type=template&id=4b123580&scoped=true"
import script from "./TodoDetailsSkeleton.vue?vue&type=script&lang=ts"
export * from "./TodoDetailsSkeleton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b123580",
  null
  
)

export default component.exports